module.exports = __webpack_public_path__ + "static/img/3.74d6d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hlw/3.png
// module id = LOtj
// module chunks = 1